/*
 * /support/[supportDocumentId] (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import {
	Container,
	Divider,
	Page,
	PageHeader,
	Skeleton,
} from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { SupportDocumentDetail } from "../../features/support/components/support-document-detail"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/support/$supportDocumentId")({
	component: SupportDocumentPage,
	loader: authPageLoader,
})

function SupportDocumentPage() {
	const { supportDocumentId } = Route.useParams()

	const { data: supportDocument, isLoading } =
		trpc.supportDocument.getByFilter.useQuery({
			where: { id: supportDocumentId },
		})

	if (isLoading) {
		return (
			<Page centerVertical={false}>
				<Container width={"xl"} padding={"lg"} gap={"sm"}>
					<Skeleton className={"h-8 w-64"} />
					<Divider />
					<div className={"space-y-3"}>
						{[1, 2, 3].map((i) => (
							<Skeleton key={i} className={"h-6 w-full"} />
						))}
					</div>
				</Container>
			</Page>
		)
	}

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"Support Document"}
					left={{
						href: "/support",
						label: "Back",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				{supportDocument ? (
					<SupportDocumentDetail supportDocument={supportDocument} />
				) : (
					<p className={"text-muted-foreground text-sm"}>
						{"Document not found."}
					</p>
				)}
			</Container>
		</Page>
	)
}
